<template>
    <section class="member-register">
        <div class="member-register-title">
            <div class="member-register-image">
                <a href="/">
                    <img :src="`/images/logo-${theme}.png`" alt="app-logo" />
                </a>
            </div>
            <div class="member-register-text">
                <p>{{ $t('members.register.blood_donors_organization') }}</p>
                <p>{{ $t('members.register.blood_donors_supporter') }}</p>
                <h1>{{ $t('members.register.blood_donor_skopje') }}</h1>
                <h5>{{ $t('members.register.account_number', { 'account': 200003392089313 }) }}</h5>
                <h5>{{ $t('members.register.bank_name') }}</h5>
            </div>
        </div>
        <hr />
        <div ref="memberRegisterMenu" class="member-register-menu">
            <h1>
                {{ $t('members.register.welcome_text', { page: appName }) }}
            </h1>
            <p>{{ $t('members.register.welcome_description') }}</p>
            <p>{{ $t('members.register.membership_volunteer') }}</p>
            <p>{{ $t('members.register.membership_symbolic_fee') }}</p>
            <p>{{ $t('members.register.bottom_video') }}</p>
            <p>{{ $t('members.register.thank_you') }}</p>
            <p>{{ $t('members.register.team_krvodaritel') }}</p>
            <hr />
            <div v-if="!!message"
                 class="member-register-alert"
            >
                {{ message }}
            </div>
            <div v-if="!!message"
                 class="member-register-success-text"
            >
                <p>{{ $t('members.register.register_thank_you') }}</p>
                <p>{{ $t('members.register.register_activities') }}</p>
                <p>{{ $t('members.register.register_membership') }}</p>
                <p>{{ $t('members.register.register_team') }}</p>
            </div>
            <div v-if="!continueToNextStage"
                 class="member-register-wrapper"
            >
                <div class="member-register-wrapper-column">
                    <form-group :label="$t('members.register.firstname')"
                                :errors="memberRegisterModelError"
                                :required="true"
                                labelFor="firstname"
                                name="firstname"
                    >
                        <input :placeholder="$t('members.register.enter_firstname')"
                               :value="memberRegisterModel.firstname"
                               type="text"
                               name="firstname"
                               id="firstname"
                               class="member-register-input"
                               @input="onUpdateModelEvent('firstname', $event.target.value)"
                        />
                    </form-group>

                    <form-group :label="$t('members.register.lastname')"
                                :errors="memberRegisterModelError"
                                :required="true"
                                labelFor="lastname"
                                name="lastname"
                    >
                        <input :placeholder="$t('members.register.enter_lastname')"
                               :value="memberRegisterModel.lastname"
                               type="text"
                               name="lastname"
                               id="lastname"
                               class="member-register-input"
                               @input="onUpdateModelEvent('lastname', $event.target.value)"
                        />
                    </form-group>

                    <form-group :label="$t('members.register.email')"
                                :errors="memberRegisterModelError"
                                :required="true"
                                labelFor="email"
                                name="email"
                    >
                        <input :placeholder="$t('members.register.enter_email')"
                               :value="memberRegisterModel.email"
                               type="email"
                               name="email"
                               id="email"
                               class="member-register-input"
                               @input="onUpdateModelEvent('email', $event.target.value)"
                        />
                    </form-group>

                    <form-group :label="$t('members.register.phone')"
                                :errors="memberRegisterModelError"
                                :required="true"
                                labelFor="phone"
                                name="phone"
                    >
                        <input :placeholder="$t('members.register.enter_phone')"
                               :value="memberRegisterModel.phone"
                               type="text"
                               name="phone"
                               id="phone"
                               class="member-register-input"
                               @input="onUpdateModelEvent('phone', $event.target.value)"
                        />
                    </form-group>

                    <form-group :label="$t('members.register.birthdate')"
                                :errors="memberRegisterModelError"
                                :required="true"
                                labelFor="birthdate"
                                name="birthdate"
                    >
                        <input :placeholder="$t('members.register.enter_birthdate')"
                               :value="memberRegisterModel.birthdate"
                               type="text"
                               name="birthdate"
                               id="birthdate"
                               class="member-register-input"
                               @input="onUpdateBirthdate('birthdate', $event.target.value)"
                        />
                    </form-group>

                    <employment-status-select :value="memberRegisterModel.employment_status"
                                              :errors="memberRegisterModelError"
                                              :label="$t('members.register.employment_status')"
                                              :placeholder="$t('members.register.select_option')"
                                              @update="onUpdateModelEvent"
                    />

                    <shirt-size-select :value="memberRegisterModel.shirt_size"
                                       :errors="memberRegisterModelError"
                                       :label="$t('members.register.shirt_size')"
                                       :placeholder="$t('members.register.select_option')"
                                       @update="onUpdateModelEvent"
                    />
                </div>

                <region-component :region="memberRegisterModel.region"
                                  :municipality="memberRegisterModel.municipality"
                                  :residence-place="memberRegisterModel.residence_place"
                                  :other-region="memberRegisterModel.otherRegion"
                                  :address="memberRegisterModel.address"
                                  :errors="memberRegisterModelError"
                                  translations-group="members.register"
                                  placeholders-group="members.register"
                                  @update="onUpdateRegionEvent"
                />

                <form-group :label="$t('members.register.image_for_membership_card')"
                            :errors="memberRegisterModelError"
                >
                    <file-upload :value="memberRegisterModel.image_for_membership_card"
                                 :delete-files="true"
                                 name="image_for_membership_card"
                                 id="image_for_membership_card"
                                 @update="onUpdateModelEvent"
                    />
                </form-group>

                <association-membership-type-select :status="memberRegisterModel.associationMembershipType"
                                                    :status-other="memberRegisterModel.associationMembershipTypeOther"
                                                    :errors="memberRegisterModelError"
                                                    translations-group="members.register"
                                                    placeholders-group="members.register"
                                                    @update="onUpdateModelEvent"
                />

                <blood-type-select :value="memberRegisterModel.klasa"
                                   :errors="memberRegisterModelError"
                                   :label="$t('members.register.blood_type')"
                                   :placeholder="$t('members.register.select_option')"
                                   :required="true"
                                   @update="onUpdateModelEvent"
                />

                <form-group :label="`${$t('members.register.blood_donation_id_number')}`"
                            :errors="memberRegisterModelError"
                            labelFor="bloodDonationIdNumber"
                            name="blood_donation_id"
                >
                    <input :placeholder="$t('members.register.enter_blood_donation_id_number')"
                           :value="memberRegisterModel.blood_donation_id"
                           type="number"
                           name="blood_donation_id"
                           id="bloodDonationIdNumber"
                           class="member-register-input"
                           @input="onUpdateModelEvent('blood_donation_id', $event.target.value)"
                    />
                </form-group>

                <form-group :label="`${$t('members.register.number_of_blood_donations')}`"
                            :errors="memberRegisterModelError"
                            labelFor="bloodDonationsNumber"
                            name="blood_donation_count"
                >
                    <input :placeholder="$t('members.register.enter_blood_donations_number')"
                           :value="memberRegisterModel.blood_donation_count"
                           type="number"
                           name="blood_donation_count"
                           id="bloodDonationsNumber"
                           class="member-register-input"
                           @input="onUpdateModelEvent('blood_donation_count', $event.target.value)"
                    />
                </form-group>

                <form-group :label="`${$t('members.register.number_of_blood_donations_stamps')}`"
                            :errors="memberRegisterModelError"
                            labelFor="bloodDonationsStampsNumber"
                            name="blood_donation_stamps_count"
                >
                    <input :placeholder="$t('members.register.enter_blood_donations_stamps_number')"
                           :value="memberRegisterModel.blood_donation_stamps_count"
                           type="number"
                           name="blood_donation_stamps_count"
                           id="bloodDonationsStampsNumber"
                           class="member-register-input"
                           @input="onUpdateModelEvent('blood_donation_stamps_count', $event.target.value)"
                    />
                </form-group>

                <form-group :label="$t('members.register.pictures_of_blood_donations_ids')"
                            :errors="memberRegisterModelError"
                >
                    <file-upload :value="memberRegisterModel.images_blood_donation_ids"
                                 :multiple="true"
                                 name="images_blood_donation_ids"
                                 id="images_blood_donation_ids"
                                 @update="onUpdateModelEvent"
                    />
                </form-group>

                <blood-donor-status-select :status="memberRegisterModel.bloodDonorStatus"
                                           :status-other="memberRegisterModel.bloodDonorStatusOther"
                                           :errors="memberRegisterModelError"
                                           translations-group="members.register"
                                           placeholders-group="members.register"
                                           @update="onUpdateModelEvent"
                />

                <plasma-blood-donor-status-select :status="memberRegisterModel.plasmaBloodDonorStatus"
                                                  :status-other="memberRegisterModel.plasmaBloodDonorStatusOther"
                                                  :stamps="memberRegisterModel.plasma_donor_stamps"
                                                  :errors="memberRegisterModelError"
                                                  translations-group="members.register"
                                                  placeholders-group="members.register"
                                                  @update="onUpdatePlasmaStatus"
                />

                <blood-donor-other-country :status="memberRegisterModel.blood_donor_in_other_country"
                                           :status-other="memberRegisterModel.blood_donor_other_country_name"
                                           :errors="memberRegisterModelError"
                                           translations-group="members.register"
                                           placeholders-group="members.register"
                                           @update="onUpdateModelEvent"
                />

                <membership-type-select :status="memberRegisterModel.membershipType"
                                        :status-other="memberRegisterModel.membershipTypeOther"
                                        :errors="memberRegisterModelError"
                                        translations-group="members.register"
                                        placeholders-group="members.register"
                                        @update="onUpdateModelEvent"
                />

                <form-group :label="$t('members.register.membership_fee_image')"
                            :errors="memberRegisterModelError"
                >
                    <file-upload :value="memberRegisterModel.membership_fee_image"
                                 :multiple="false"
                                 name="membership_fee_image"
                                 id="membership_fee_image"
                                 @update="onUpdateModelEvent"
                    />
                </form-group>

                <form-group :label="$t('members.register.already_association_member')"
                            :errors="memberRegisterModelError"
                            name="already_association_member"
                >
                    <select-box :options="alreadyAssociationMemberOptions"
                                :value="memberRegisterModel.already_association_member"
                                :placeholder="$t('members.register.select_option')"
                                :default-item="null"
                                id="already_association_member"
                                name="already_association_member"
                                @update="onUpdateModelEvent"
                    />
                </form-group>

                <form-group v-if="memberRegisterModel.already_association_member === 'yes'"
                            :label="$t('members.register.already_association_images')"
                            :errors="memberRegisterModelError"
                            name="already_association_member_images"
                >
                    <file-upload :value="memberRegisterModel.already_association_member_images"
                                 :multiple="false"
                                 name="already_association_member_images"
                                 id="already_association_member_images"
                                 @update="onUpdateModelEvent"
                    />
                </form-group>
            </div>
            <div v-else
                 class="member-register-wrapper"
            >
                <checkbox :value="agreed"
                          :disabled="!!bloodDonorFormLoader"
                          name="agree"
                          @update="onAgreeChangeEvent"
                >
                    {{ $t('members.register.register_agreement') }}
                </checkbox>
            </div>
        </div>
        <div v-if="!continueToNextStage"
             class="member-register-footer"
        >
            <a href="/members/login?o=false">
                {{ $t('members.login.go_to_login') }}
            </a>

            <button :disabled="!isContinueAllowed"
                    @click="onContinueEvent"
            >
                {{ $t('words.continue') }}
            </button>
        </div>
        <div v-else
             class="member-register-footer"
        >
            <a v-if="!bloodDonorFormLoader"
               href="#"
               @click.prevent="continueToNextStage = false; agreed = false;"
            >
                {{ $t('members.register.back_to_form') }}
            </a>

            <button v-if="!bloodDonorFormLoader"
                    :disabled="!agreed"
                    @click="onSaveBloodDonorEvent"
            >
                {{ $t('words.register') }}
            </button>

            <button-loader v-if="!!bloodDonorFormLoader"
                           type="small"
            />
        </div>
        <div class="member-register-images">
            <img v-for="(image, index) in lightBox.images"
                 :key="index"
                 :src="image"
                 alt="image"
                 @click.prevent="lightBox.visible = true; lightBox.index = index"
             />
        </div>
        <vue-easy-lightbox :visible="lightBox.visible"
                           :imgs="lightBox.images"
                           :index="lightBox.index"
                           :scroll-disabled="false"
                           teleport="body"
                           @hide="lightBox.visible = false"
        />
        <YouTube :src='youtubeVideo'
                 ref="youtube"
                 class="youtube-video"
        />
    </section>
</template>

<script>
import PageLoader from '../../../../Custom/Shared/PageLoader/PageLoader';
import MembersViewModel from '../MembersViewModel';
import FormGroup from '../../../Components/Forms/Holders/FormGroup';
import FileUpload from '../../../Components/Forms/FileUpload/FileUpload';
import EmploymentStatusSelect
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/EmploymentStatusSelect/EmploymentStatusSelect';
import AssociationMembershipTypeSelect
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/MemebershipStatus/AssociationMembershipTypeSelect';
import ShirtSizeSelect
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/ShirtSizeSelect/ShirtSizeSelect';
import MultiWrite from '../../../Components/Forms/MultiWrite/MultiWrite';
import BirthdateSelect from '../../../Components/Forms/Select/BirthdateSelect';
import RegionComponent
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/RegionComponent/RegionComponent';
import MembershipTypeSelect
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/MemebershipStatus/MembershipTypeSelect';
import BloodDonorOtherCountry
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/BloodDonor/BloodDonorOtherCountry';
import PlasmaBloodDonorStatusSelect
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/BloodDonor/PlasmaBloodDonorStatusSelect';
import BloodDonorStatusSelect
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/BloodDonor/BloodDonorStatusSelect';
import MemberRegisterForm from './MemberRegisterForm';
import BloodTypeSelect
    from '../../BloodDonors/BloodDonorDetails/BloodDonorProfile/Components/BloodDonor/BloodTypeSelect';
import HandlesDateAndTime from '../../../Concerns/HandlesDateAndTime';
import HandlesAttachments from '../../../Concerns/HandlesAttachments';
import Checkbox from '../../../Components/Forms/Checkbox/Checkbox';
import ValidateEmail from '../../../../Src/Utils/Email/ValidateEmail';
import ButtonLoader from '../../../Components/Loader/ButtonLoader';
import HandlesResponse from '../../../Concerns/HandlesResponse';
import YouTube from 'vue3-youtube';
import SelectBox from '../../../Components/Forms/SelectBox/SelectBox';
import VueEasyLightbox from 'vue-easy-lightbox';
import Translate from '../../../../Src/Modules/Localization/Translate';

export default {
    name: 'MemberLogin',
    mixins: [
        MembersViewModel,
        MemberRegisterForm,
        HandlesDateAndTime,
        HandlesAttachments,
        HandlesResponse,
    ],
    components: {
        ButtonLoader,
        Checkbox,
        FormGroup,
        FileUpload,
        EmploymentStatusSelect,
        AssociationMembershipTypeSelect,
        ShirtSizeSelect,
        MultiWrite,
        BirthdateSelect,
        RegionComponent,
        MembershipTypeSelect,
        BloodDonorOtherCountry,
        PlasmaBloodDonorStatusSelect,
        BloodDonorStatusSelect,
        BloodTypeSelect,
        YouTube,
        SelectBox,
        VueEasyLightbox,
    },
    data() {
        return {
            continueToNextStage: false,
            agreed: false,
            message: null,
            lightBox: {
                visible: false,
                index: 0,
                images: [
                    '/images/pristapnici/front.jpg',
                    '/images/pristapnici/back.jpg',
                ],
            },
            alreadyAssociationMemberOptions: [
                {
                    label: Translate('words.yes'),
                    value: 'yes'
                },
                {
                    label: Translate('words.no'),
                    value: 'no'
                }
            ],
        };
    },
    computed: {
        isContinueAllowed() {
            const fields = {
                firstname: {
                    valid: false,
                    min: 3,
                    max: 25,
                },
                lastname: {
                    valid: false,
                    min: 3,
                    max: 25,
                },
                email: {
                    valid: false,
                    email: true,
                },
                phone: {
                    valid: false,
                    min: 3,
                    max: 25,
                },
                birthdate: {
                    valid: false,
                    min: 10,
                    max: 10,
                },
                region: {
                    valid: false,
                },
                address: {
                    valid: false,
                },
                klasa: {
                    valid: false,
                },
            };

            for (let field in fields) {
                const fieldValue = fields[field];
                const value = this.memberRegisterModel[field];

                if (fieldValue.hasOwnProperty('min') && fieldValue.hasOwnProperty('max')) {
                    const { min, max } = fieldValue;

                    fields[field].valid = !!value && value.length >= min && value.length <= max;

                    continue;
                }

                if (fieldValue.hasOwnProperty('email')) {
                    fields[field].valid = !!value && !!ValidateEmail(value);

                    continue;
                }

                fields[field].valid = !!value;
            }

            const invalidValues = Object.keys(fields)
                .filter(item => {
                    return !fields[item].valid;
                });

            return !invalidValues.length;
        },
    },
    methods: {
        onAgreeChangeEvent(value) {
            this.agreed = value;
        },
        initializeRegistrationMessage() {
            const hasRegistrationStatus = localStorage.getItem('mrs');

            if (!hasRegistrationStatus) {
                return;
            }

            this.message = this.$t('blood_donors.create_donor_successfully');
            localStorage.removeItem('mrs');
        },
        onContinueEvent() {
            this.continueToNextStage = true;

            this.$refs.memberRegisterMenu.scrollIntoView({
                behavior: 'smooth'
            });
        },
    },
    created() {
        this.initializeRegistrationMessage();
    },
    mounted() {
        PageLoader.removeLoader();
    },
}
</script>